module.exports = __webpack_public_path__ + "img/t5.68c19951.svg";